import React from "react"
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import StripeSepaForm from "./StripeSepaForm"
import { injectIntl } from "react-intl"
import ContactService from "../../../state/contact/services/ContactService"

type OwnProps = {
    contactId: string,
    publicKey: string,
    saveAndChargeLater: boolean,
    onClose: () => void,
    onSubmit: () => void,
    integrationKey: string,
    testMode: boolean,
}

const StripeSepaContainer = (props: OwnProps) => {
    const handleSubmitSetupIntent = (result) => {
        if (result.error) {
            return
        }

        const payment_method = result.setupIntent.payment_method

        const payload = {
            "paymentMethod": payment_method,
            "integrationKey": props.integrationKey
        }
        ContactService.SaveSEPABankOnFile(props.contactId, payload).then(() => {
            props.onSubmit()
            props.onClose()
        })
    }

    const stripePromise = loadStripe(props.publicKey)
    return (
        <Elements stripe={stripePromise}>
            <StripeSepaForm
                contactId={props.contactId}
                saveAndChargeLater={props.saveAndChargeLater}
                onSetupIntentSubmit={handleSubmitSetupIntent}
                testMode={props.testMode} />
        </Elements>
    )
}

export default injectIntl(StripeSepaContainer)


// WEBPACK FOOTER //
// ./src/common/sepa/stripe/StripeSepaContainer.tsx